<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
export default {
  components: { swiper, swiperSlide },
  props: {
    aboutCompany: {
      type: Array,
      default: () => {},
    },
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 1,
        speed: 600,
        slidesPerGroup: 1,
        spaceBetween: 0,
        centeredSlides: true,
        loop: true,
        effect: 'fade',
        breakpoints: {
          768: {
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
          },
        },
      },
    }
  },
  methods: {
    onNext() {
      this.$refs.carousel.swiper.slideNext()
    },
    onPrev() {
      this.$refs.carousel.swiper.slidePrev()
    },
  },
}
</script>
<template>
  <section :class="$style.surrounding" class="surrounding">
    <div class="container">
      <div class="introduction__Description">
        <BaseSectionTitle title="優質環境" class="text-center" />
      </div>
      <div class="introduction__List">
        <swiper v-if="!!aboutCompany.length" ref="carousel" :options="swiperOption" class="carouselList">
          <swiper-slide v-for="(item, $index) in aboutCompany" :key="$index" class="carouselItem bg-white">
            <div class="contentBox">
              <!-- <BaseSectionTitle2 class="text-center" :title="item.title"/> -->
              <div class="title text-md-center">
                {{ item.title }}
              </div>
              <div class="content text-gray-6">
                {{ item.description }}
              </div>
            </div>
          </swiper-slide>
        </swiper>
        <div class="navigationBox">
          <button class="navigationBtn isPrev" @click="onPrev">
            <i class="fal fa-chevron-left"></i>
          </button>
          <button class="navigationBtn isNext" @click="onNext">
            <i class="fal fa-chevron-right"></i>
          </button>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
  </section>
</template>
<style lang="scss" module>
.surrounding {
  @include max-md {
    padding-bottom: 0;
  }

  :global {
    .introduction__Box {
      // padding: 50px 114px;
      // line-height: 2;
      // border: 1px solid #E6E6E6;
      // border-radius: 0 2px 2px 0;
      // box-shadow: 0 0 8px rgba(33, 69, 88, 0.16);

      @include max-lg {
        padding: 2rem;
        font-size: 1rem;
      }

      @include max-md {
        padding: 1rem;
        font-size: 0.875rem;
      }

      .box {
        &__Top {
        }

        &__Bottom {
          @include min-md {
            position: relative;
            // &:before {
            //   content: '';
            //   position: absolute;
            //   left: 0;
            //   top: 0;
            //   width: 100%;
            //   height: 1px;
            //   background-image: linear-gradient(to right, #e6e6e6 60%, rgba(255, 255, 255, 0) 40%);
            //   background-size: 40px 1px;
            //   background-repeat: repeat-x;
            // }
          }
        }

        &__title {
          color: $color-gray-5;

          @include max-md {
            // display: block;
          }
        }

        &__icon {
          margin-right: 20px;
          font-size: 20px;
          color: $color-primary;
        }
      }
    }

    .introduction__Description {
      padding-top: $section-padding;
      line-height: 2;

      // @include max-lg {
      //   padding-top: $section-lg-padding;
      // }

      .title {
        font-size: 1.5rem;

        @include max-md {
          font-size: 1.25rem;
        }
      }

      .description {
        color: $color-gray-6;
      }
    }

    .introduction__List {
      position: relative;
      // padding-top: $section-padding;
      background: #ffffff 0% 0% no-repeat padding-box;
      box-shadow: 0px 2px 4px #21455829;
      border: 1px solid $color-gray-3;

      @include max-lg {
        padding-top: $section-lg-padding;
        margin-right: -$container-gap;
        margin-bottom: $section-lg-padding;
        margin-left: -$container-gap;
      }

      .carouselList {
        @include max-md {
          margin-left: $container-gap;
          margin-right: $container-gap;
        }
      }

      .carouselItem {
        // position: relative;
        // height: 700px;
        // background-repeat: no-repeat;
        // background-position: center;
        // background-size: cover;

        // @include max-md {
        //   height: 500px;
        // }
      }

      .contentBox {
        width: 100%;
        max-width: 960px;
        padding: 4.35rem 19px;
        margin: 0 auto;
        // position: absolute;
        // top: 0;
        // right: 0;
        // bottom: 0;
        // width: 420px;
        // font-size: 1rem;
        // line-height: 1.75;
        // background: rgba(11, 16, 19, 0.7);
        @include max-md {
          padding: 1.25rem $container-gap;
          overflow: auto;
          height: 55vh;
        }
        @include max-2sm {
          height: 60vh;
          padding-bottom: 1.5rem;
        }
        .title {
          position: relative;
          margin-bottom: 60px;
          font-size: 1.5rem;
          font-weight: medium;
          color: $color-gray-7;
          @include max-md {
            font-size: 1.125rem;
            margin-bottom: 2rem;
          }
          &::before {
            position: absolute;
            right: 0;
            bottom: -10px;
            left: 50%;
            width: 30px;
            height: 5px;
            content: '';
            background: $color-primary;
            border-radius: 3px;
            transform: translateX(-50%);
            @include max-md {
              display: none;
            }
          }
        }
        .content {
          @include max-md {
            line-height: 2;
          }
        }
      }

      .navigationBox {
        @include max-md {
          display: none;
        }
        .navigationBtn {
          position: absolute;
          top: 54%;
          right: 0;
          // transform: translateY(-50%);
          z-index: 3;
          width: 53px;
          height: 53px;
          font-size: 1rem;
          line-height: 53px;
          color: $color-gray-6;
          text-align: center;
          background: transparent;
          border: 1px solid $color-gray-6;
          border-radius: 100%;
          transition: 0.3s;

          @media screen and (max-width: 1250px) {
            top: 87%;
          }

          @include max-md {
            width: 40px;
            height: 40px;
            line-height: 40px;
          }

          &:focus {
            color: $color-primary;
            border-color: $color-primary;
            outline: transparent;
          }

          &:hover {
            color: $color-primary;
            border-color: $color-primary;
          }

          &.isPrev {
            // margin-right: 300px;
            left: 6%;

            @media screen and (max-width: 1250px) {
              left: auto;
              margin-right: 100px;
              // right: 0;
            }

            @include max-md {
              // margin-right: 130px;
            }
            &:hover {
              transform: translateX(-5px);
            }
          }

          &.isNext {
            // margin-right: 220px;
            right: 7%;

            @media screen and (max-width: 1250px) {
              right: 0;
              margin-right: 35px;
            }

            @include max-md {
              // margin-right: 48px;
            }
            &:hover {
              transform: translateX(5px);
            }
          }
        }
      }
      .swiper-pagination {
        margin-bottom: 1.25rem;
      }
      // .swiper-button {

      //   &.swiper-prev {
      //     left: 60px;
      //   }
      //   &.swiper-next {
      //     right: calc(100vw - 20px)
      //   }
      // }
    }
  }
}
</style>
